import { render, staticRenderFns } from "./ManageAsin.vue?vue&type=template&id=1bd2269c&scoped=true&"
import script from "./ManageAsin.vue?vue&type=script&lang=ts&"
export * from "./ManageAsin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd2269c",
  null
  
)

export default component.exports